import type { ChangeEventHandler, SubmitEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack } from '@mui/material';

import { PasswordField } from '@/components/common/PasswordField';

type CurrentPasswordStepProps = {
  currentPassword: string;
  currentPasswordError?: string;
  isSubmitting: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onSubmit: SubmitEventHandler<HTMLFormElement>;
};

export function CurrentPasswordStep({
  currentPassword,
  currentPasswordError,
  isSubmitting,
  onChange,
  onSubmit,
}: CurrentPasswordStepProps) {
  const { t } = useTranslation();

  return (
    <Stack sx={{ width: '100%', gap: 2 }} data-qa-element-id="password-change-current-step">
      <Box component="form" onSubmit={onSubmit} noValidate>
        <PasswordField
          name="currentPassword"
          labelKey="login.passwordChangeV3.currentPassword"
          autoFocus={true}
          autoComplete="current-password"
          value={currentPassword}
          error={currentPasswordError}
          disabled={isSubmitting}
          onChange={onChange}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="secondary"
          disabled={isSubmitting || currentPassword.length === 0}
          data-qa-element-id="password-change-next-button"
        >
          {t('login.passwordChangeV3.nextButton')}
        </Button>
      </Box>
    </Stack>
  );
}
